var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.elementsUsable)?_c('div',[_vm._t("default",null,{"instance":_vm.stripe,"elements":_vm.elements})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }